import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=c9b9ae10&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=c9b9ae10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b9ae10",
  null
  
)

export default component.exports